// routes value

export const MAIN_ROUTES = {
  PLANNING: {
    TITLE: "برنامه‌ریزی",
    PATH: "planning",
  },
  PROFILE: {
    TITLE: "حساب کاربری",
    PATH: "profile",
  },
  PAY: {
    TITLE: "ارتقا",
    PATH: "pay",
  },
  TESTS: {
    TITLE: "آزمون ها",
    PATH: "tests",
  },
  SUPPORT: {
    TITLE: "پشتیبانی",
    PATH: "support",
  },
  DASHBOARD: {
    TITLE: "داشبورد",
    PATH: "dashboard",
  },
  STORE: {
    TITLE: "طرح ها | شخصی سازی |‌ فاکتور ",
    PATH: "store",
  },
  CONSULTANCY: {
    TITLE: "مشاوره",
    PATH: "consultancy",
  },
  SESSION: {
    TITLE: "خرید مشاوره",
    PATH: "session",
  },
  HALL: {
    TITLE: "تالار اساتید",
    PATH: "bio",
  },
};

export const ROUTES = {
  // Planning routes
  MAIN_PLANNING: {
    TITLE: "برنامه ریزی",
    PATH: `/${MAIN_ROUTES.PLANNING.PATH}`,
  },
  BOOK_MANAGEMENT: {
    TITLE: "کتابخانه",
    PATH: `/${MAIN_ROUTES.PLANNING.PATH}/book-management`,
  },
  ADD_RESOURCES: {
    TITLE: "افزودن منابع",
    PATH: `/${MAIN_ROUTES.PLANNING.PATH}/add-resources`,
  },
  MICROSCOPIC_PLAN: {
    TITLE: "برنامه میکروسکوپی",
    PATH: `/${MAIN_ROUTES.PLANNING.PATH}/microscopic-plan`,
    ICON: "fas_fa_microscope",
  },
  // TIMING_PLAN_OLD: {
  //   TITLE: 'روتین هفتگی(قدیم)',
  //   PATH: `/${MAIN_ROUTES.PLANNING.PATH}/test`
  // },
  TIMING_PLAN: {
    TITLE: "روتین هفتگی",
    PATH: `/${MAIN_ROUTES.PLANNING.PATH}/timing-plan`,
  },
  TELESCOPIC_PLAN: {
    TITLE: "آنالیز تلسکوپی",
    PATH: `/${MAIN_ROUTES.PLANNING.PATH}/telescopic-plan`,
  },
  CONSULTANT: {
    TITLE: "مشاوران من",
    PATH: `/${MAIN_ROUTES.CONSULTANCY.PATH}`,
  },
  PACKAGES: {
    TITLE: "خرید طرح",
    PATH: `/${MAIN_ROUTES.STORE.PATH}/packages`,
  },
  PLAN_CUSTOMIZING: {
    TITLE: "سفارشی کردن طرح",
    PATH: `/${MAIN_ROUTES.STORE.PATH}/plan-customizing`,
  },
  INVOICE: {
    TITLE: "جزئیات سفارش",
    PATH: `/${MAIN_ROUTES.STORE.PATH}/invoice`,
  },
  PACKAGE: {
    TITLE: "محتوی بسته",
    PATH: `/${MAIN_ROUTES.STORE.PATH}/package`,
  },
  REFUNDED_INVOICE: {
    TITLE: "برگشت سفارش",
    PATH: `/${MAIN_ROUTES.STORE.PATH}/refunded-invoice`,
  },
  TEACHER_SELECTION: {
    TITLE: "اساتید پیشنهادی",
    PATH: `/${MAIN_ROUTES.STORE.PATH}/teacher-selection`,
  },
  // Profile routes
  PROFILE: {
    TITLE: "حساب کاربری",
    PATH: `/${MAIN_ROUTES.PROFILE.PATH}`,
  },
  PROFILE_ACCOUNT: {
    TITLE: "اطلاعات شخصی",
    PATH: `myInfo`,
    ICON: "FA_R-user",
  },
  PROFILE_ENROLLMENT: {
    TITLE: "اطلاعات آزمون",
    PATH: `enrollment`,
    ICON: "far-fa-file-invoice",
  },
  PROFILE_INVOICES: {
    TITLE: "سفارش ها",
    PATH: `invoices`,
    ICON: "FA_R-receipt",
  },
  PROFILE_WALLET: {
    TITLE: "کیف پول",
    PATH: `wallet`,
    ICON: "far_fa_wallet",
  },
  PROFILE_SETTING: {
    TITLE: "تنظیمات",
    PATH: `setting`,
    ICON: "FA_R-gear",
  },
  // Pay routes
  CONSULTANCY_HISTORY: {
    TITLE: "تاریچه مشاور",
    PATH: `/${MAIN_ROUTES.CONSULTANCY.PATH}/history`,
  },
  COUNSELOR_PROFILE: {
    TITLE: "پروفایل مشاور",
    PATH: `/${MAIN_ROUTES.CONSULTANCY.PATH}/counselor`,
  },
  PACKAGES_OLD: {
    TITLE: "خرید طرح",
    PATH: `/${MAIN_ROUTES.PLANNING.PATH}/packages`,
  },
  // reserveAppointment
  RESERVE_APPOINTMENT: {
    TITLE: "رزرو مشاوره",
    PATH: `/reserve-appointment`,
  },
  // Tests routes
  QUIZZES: {
    TITLE: "آزمون آزمایشی",
    PATH: `/${MAIN_ROUTES.TESTS.PATH}/quizzes`,
  },
  EXAM_LANDING: {
    TITLE: "آزمون روانشناسی",
    PATH: `/${MAIN_ROUTES.TESTS.PATH}/exam-landing`,
  },
  // Support routes
  MESSAGES: {
    TITLE: "پشتیبانی",
    PATH: `/${MAIN_ROUTES.SUPPORT.PATH}/messages`,
  },
  CHAT: {
    TITLE: "گفتگو با مشاور",
    PATH: `/${MAIN_ROUTES.CONSULTANCY.PATH}/chat`,
  },
  // Session routes
  SESSION: {
    TITLE: "خرید مشاوره",
    PATH: `/${MAIN_ROUTES.SESSION.PATH}`,
  },
  SESSION_LANDING: {
    TITLE: "خرید مشاوره",
    PATH: `/${MAIN_ROUTES.SESSION.PATH}/landing`,
  },
  SESSION_FORM: {
    TITLE: "فرم خرید مشاوره",
    PATH: `/${MAIN_ROUTES.SESSION.PATH}/form`,
  },
  SESSION_REQUEST: {
    TITLE: "فرم خرید مشاوره",
    PATH: `/${MAIN_ROUTES.SESSION.PATH}/request`,
  },

  // Dashboard routes
  DASHBOARD: {
    TITLE: "داشبورد",
    PATH: "/dashboard",
  },
  // PLANING_OFFICE: {
  //   TITLE: 'دفتر برنامه ریزی',
  //   PATH: `/${MAIN_ROUTES.PLANNING.PATH}/microscopic-plan`
  // },
  CONSULTANCY: {
    TITLE: "مشاوره تحصیلی",
    PATH: `/${MAIN_ROUTES.CONSULTANCY.PATH}`,
  },
  // Hall
  HALL: {
    TITLE: "تالار اساتید",
    PATH: `/${MAIN_ROUTES.HALL.PATH}`,
  },
  HALL_LANDING: {
    TITLE: "تالار اساتید",
    PATH: `/${MAIN_ROUTES.HALL.PATH}/landing`,
  },
  HALL_CUSTOM_LANDING: {
    TITLE: "تالار اساتید",
    PATH: `/${MAIN_ROUTES.HALL.PATH}/landings`,
  },
  HALL_FIELD: {
    TITLE: "آزمون ها",
    PATH: `/${MAIN_ROUTES.HALL.PATH}/topic`,
  },
  HALL_SEARCH: {
    TITLE: "جستحو",
    PATH: `/${MAIN_ROUTES.HALL.PATH}/search`,
  },

  // Inital form
  INITIAL: {
    TITLE: "اطلاعات هدف",
    PATH: "/initial",
  },
  SETTINGS: {
    TITLE: "تنظیمات",
    PATH: `/${MAIN_ROUTES.PLANNING.PATH}/settings`,
    ICON: "FA_R-gear",
  },
  SETTINGS_MAIN: {
    TITLE: "تنظیمات",
    PATH: `main`,
    ICON: "FA_R-gear",
  },
  SETTINGS_EXAM: {
    TITLE: "اطلاعات آزمون",
    PATH: `exam`,
    ICON: "far-fa-file-invoice",
  },
  // others routes
  NOT_FOUND: {
    TITLE: "404",
    PATH: "*",
  },
  DELETE_ACCOUNT: {
    TITLE: "حذف حساب کاربری",
    PATH: "/delete-account",
  },
};
